import email from "../images/socialIcons/email.png";
import github from "../images/socialIcons/github.png";
import linkedin from "../images/socialIcons/linkedin.png";
import X from "../images/socialIcons/xIcon.png";
import youtube from "../images/socialIcons/youtube.png";


export const socials = [
    {
      icon: email,
      url: "mailto: osharpe001@gmail.com",
    },
    {
      icon: github,
      url: "https://github.com/OSharpe001",
    },
    {
      icon: linkedin,
      url: "https://www.linkedin.com/in/omarisharpe",
    },
    {
      icon: X,
      url: "https://twitter.com/OSharpe001",
    },
    {
      icon: youtube,
      url: "https://www.youtube.com/channel/UCSkr3q6LHUwPqWdCdQZY8ZA",
    },
  ];